import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=6c4a5b2a&scoped=true&"
import script from "./Commands.vue?vue&type=script&lang=js&"
export * from "./Commands.vue?vue&type=script&lang=js&"
import style0 from "./Commands.vue?vue&type=style&index=0&id=6c4a5b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a5b2a",
  null
  
)

export default component.exports